import axios from 'axios';

export const masterclassApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
masterclassApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errorMessage = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail?.message) return detail.message;
  return 'No se pudo completar la solicitud. Intenta de nuevo.';
};

export const phaseLabel = (phase) => ({
  Definicion: 'Definición', Epidemiologia: 'Epidemiología', Fisiopatologia: 'Fisiopatología',
  Factores_Riesgo: 'Factores de riesgo', Diagnostico: 'Diagnóstico',
  Tratamiento_Materno: 'Tratamiento materno', Protocolo_Intraparto: 'Protocolo intraparto',
  Cuidados_Neonato: 'Cuidados del neonato', Alimentacion_Neonato: 'Alimentación del neonato',
  Profilaxis_Neonato: 'Profilaxis neonatal', Diagnostico_Lactante: 'Diagnóstico del lactante',
  Perlas_Consolidacion: 'Perlas de consolidación',
}[phase] || phase?.replace(/_/g, ' '));